export default __webpack_public_path__ + "static/media/vantagens-4.4cb093c4.svg";